export default function CustomPanelContent ({file, url, img, longText}) {
	return (
		<>
			{/* <iframe src={file ? file : url} width="100%" height="600px" /> */}
			<iframe src={file ? file : url} width="95%" height="99%" />
		</>		
	)
}